/**
 * Contextual starter prompts for the AI assistant.
 * Pure module: returns i18n keys so it can be unit-tested without React.
 */
export type AiAudience = 'caregiver' | 'family' | 'company';

export interface SuggestionInput {
  route: string;
  audience: AiAudience;
  hasPatient: boolean;
  hasActiveShift: boolean;
}

export function getSuggestionKeys(input: SuggestionInput): string[] {
  const keys: string[] = [];
  const { route, audience, hasPatient, hasActiveShift } = input;

  if (hasActiveShift) keys.push('shiftNow', 'nextTasks');

  if (audience === 'company' && route.includes('/company')) {
    keys.push('companyCoverage', 'companyPunctuality', 'companyGaps');
  }

  if (audience === 'family' && hasPatient) {
    keys.push('patientToday', 'vitalsWeek', 'whoIsOnShift');
  }

  if (audience === 'caregiver' && hasPatient) {
    keys.push('lateTasks', 'carePlanSummary', 'vitalRanges');
  }

  if (!hasPatient) keys.push('howToStart');

  if (route.includes('/shift/') || route.includes('/shifts')) keys.push('summarizeLastShift');

  return [...new Set(keys)].slice(0, 4);
}
